import React from 'react';
import { Container, ComponentsArea } from './Styled';
import { TiMessage } from "react-icons/ti";
import { FiUserCheck } from "react-icons/fi";
import { FaCreativeCommonsRemix } from "react-icons/fa"
import Item from '../Item/Item';
import NodeTypes from '../../../../../model/workflowEditor/NodeTypes';
import GroupItem from '../groupItem/GroupItem';

type ComponentSectionProps = {
}

const ComponentSection: React.FunctionComponent<ComponentSectionProps> = () => {
  return (
    <Container>
   
   <ComponentsArea>
      <Item  Icon={<FiUserCheck size={24}/>} title={'Intent utilisateur'} nodeType={NodeTypes.userIntentNode}/>
      <Item Icon={<TiMessage size={24}/>} title={'Bot message'} nodeType={NodeTypes.botMessageNode}/>
      <GroupItem Icon={<FaCreativeCommonsRemix size={24}/>} title={'Store'} nodeType={NodeTypes.botMessageNode}>
        <Item  Icon={<FiUserCheck size={24}/>} title={'Custom action'} nodeType={NodeTypes.actionNode}/>
      </GroupItem>
   </ComponentsArea>
   </Container>
  );
}

export default ComponentSection;
